import { useEffect, useState } from "react";
import { makeRequest } from "../makeRequest";

const useFetch = (url, token) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        var headers = {
          'Content-Type': 'application/json'
        };
        if (token !== "NoToken") {
          headers = {'Authorization': "Bearer " + token, 'Content-Type': 'application/json'};
        }
        const res = await makeRequest.get(url + `&timestamp=${new Date().getTime()}`, { headers: headers });
        //console.log(JSON.stringify(res.data));
        setData(res.data);
      } catch (err) {
        setError(true);
      }
      setLoading(false);
    };
    fetchData();
  }, [url]);

  return { data, loading, error };
};

export default useFetch;
